// import React, { useEffect, useState } from 'react';
// import Swal from 'sweetalert2';
// import { connect } from 'react-redux';
// import { setBreadcrumbItems } from "../../store/actions";
// import { useParams, useNavigate } from "react-router-dom";

// const DatosSocio = (props) => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [socio, setSocio] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     celular: "",
//     documento: "",
//     fechaNacimiento: "",
//     direccion: "",
//     // Agregá acá los campos que quieras editar
//   });

//   useEffect(() => {
//     props.setBreadcrumbItems('Editar Socio', [
//       { title: "Socios", link: "#" },
//       { title: "Editar", link: "#" },
//     ]);
//     fetchSocio();
//     // eslint-disable-next-line
//   }, [id]);

//   const fetchSocio = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`https://asijeminapis.website:5248/api/members/${id}`);
//       const data = await res.json();
//       setSocio(data);
//       setForm({
//         name: data.name || "",
//         email: data.email || "",
//         celular: data.celular || "",
//         documento: data.documento || "",
//         fechaNacimiento: data.fechaNacimiento ? data.fechaNacimiento.substring(0,10) : "",
//         direccion: data.direccion || "",
//         // Asegurate de agregar acá todos los campos que quieras permitir editar
//       });
//     } catch (e) {
//       Swal.fire({ icon: 'error', title: 'No se pudo obtener los datos del socio.' });
//     }
//     setLoading(false);
//   };

//   const handleChange = e => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const res = await fetch(`https://asijeminapis.website:5248/api/members/${id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form)
//       });
//       if (res.ok) {
//         Swal.fire({ icon: "success", title: "Socio actualizado." });
//         navigate(-1); // Vuelve a la lista anterior, o usa navigate("/ruta")
//       } else {
//         Swal.fire({ icon: "error", title: "Error al actualizar socio." });
//       }
//     } catch (err) {
//       Swal.fire({ icon: "error", title: "Error de red." });
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="container mt-4">
//       <h2>Editar Socio</h2>
//       {loading && <p>Cargando...</p>}
//       {!loading && socio && (
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3">
//             <label>Nombre</label>
//             <input type="text" name="name" className="form-control" value={form.name} onChange={handleChange} required />
//           </div>
//           <div className="mb-3">
//             <label>Email</label>
//             <input type="email" name="email" className="form-control" value={form.email} onChange={handleChange} required />
//           </div>
//           <div className="mb-3">
//             <label>Celular</label>
//             <input type="text" name="celular" className="form-control" value={form.celular} onChange={handleChange} required />
//           </div>
//           <div className="mb-3">
//             <label>Documento</label>
//             <input type="text" name="documento" className="form-control" value={form.documento} onChange={handleChange} required />
//           </div>
//           <div className="mb-3">
//             <label>Fecha de Nacimiento</label>
//             <input type="date" name="fechaNacimiento" className="form-control" value={form.fechaNacimiento} onChange={handleChange} required />
//           </div>
//           <div className="mb-3">
//             <label>Dirección</label>
//             <input type="text" name="direccion" className="form-control" value={form.direccion} onChange={handleChange} />
//           </div>
//           {/* Agrega más campos según tu modelo */}
//           <button type="submit" className="btn btn-primary" disabled={loading}>
//             Actualizar
//           </button>
//           <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)} disabled={loading}>
//             Cancelar
//           </button>
//         </form>
//       )}
//     </div>
//   );
// };

// export default connect(null, { setBreadcrumbItems })(DatosSocio);



import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";
import { useParams, useNavigate } from "react-router-dom";

const DatosSocio = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    img: '',
    email: '',
    celular: '',
    celular2: '',
    fechaNacimiento: '',
    genero: '',
    direccion: '',
    departamento: '',
    padre: '',
    madre: '',
    documento: '',
    observaciones: '',
    rateId: '',
    siblings: [],
    discountIds: [],
    isPaymentResponsible: false,
    membershipStatus: 'activo'
  });

  const [rates, setRates] = useState([]);
  const [sociosDisponibles, setSociosDisponibles] = useState([]);
  const [descuentosDisponibles, setDescuentosDisponibles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    props.setBreadcrumbItems('Editar Socio', [
      { title: "Socios", link: "#" },
      { title: "Editar", link: "#" },
    ]);

    fetchSocio();
    fetchAdicionales();
  }, [id]);

  const fetchSocio = async () => {
    setLoading(true);
    try {
      const res = await fetch(`https://asijeminapis.website:5248/api/members/${id}`);
      const data = await res.json();
      if (!res.ok) throw new Error("No se pudo cargar el socio.");

      setForm({
        ...form,
        ...data,
        fechaNacimiento: data.fechaNacimiento?.substring(0, 10) || '',
        siblings: data.siblings || [],
        discountIds: data.discountIds || [],
        isPaymentResponsible: data.isPaymentResponsible || false
      });
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: error.message });
    }
    setLoading(false);
  };

  const fetchAdicionales = () => {
    fetch("https://asijeminapis.website:5248/api/rates")
      .then(res => res.json())
      .then(data => setRates(data))
      .catch(err => console.error("Error al cargar tarifas:", err));

    fetch("https://asijeminapis.website:5248/api/members")
      .then(res => res.json())
      .then(data => {
        const activosOrdenados = data.filter(m => m.status === "activo").sort((a, b) => b.id.localeCompare(a.id));
        setSociosDisponibles(activosOrdenados);
      })
      .catch(err => console.error("Error al cargar socios:", err));

    fetch("https://asijeminapis.website:5248/api/discounts")
      .then(res => res.json())
      .then(data => setDescuentosDisponibles(data.filter(d => d.isActive)))
      .catch(err => console.error("Error al cargar descuentos:", err));
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const toggleHermano = (id) => {
    setForm(prev => ({
      ...prev,
      siblings: prev.siblings.includes(id)
        ? prev.siblings.filter(s => s !== id)
        : [...prev.siblings, id]
    }));
  };

  const toggleDescuento = (id) => {
    setForm(prev => ({
      ...prev,
      discountIds: prev.discountIds.includes(id)
        ? prev.discountIds.filter(d => d !== id)
        : [...prev.discountIds, id]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`https://asijeminapis.website:5248/api/members/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });

      if (res.ok) {
        Swal.fire({ icon: "success", title: "Socio actualizado correctamente" });
        navigate(-1);
      } else {
        const data = await res.json();
        Swal.fire({ icon: "error", title: "Error", text: data.error || "Ocurrió un error al actualizar." });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error de red" });
    }
    setLoading(false);
  };

  return (
    <div className="container mt-4">
      <h2>Editar Socio</h2>
      {loading ? <p>Cargando...</p> : (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Nombre</label>
              <input type="text" name="name" className="form-control" value={form.name} onChange={handleChange} required />
            </div>
            <div className="col-md-4 mb-3">
              <label>Email</label>
              <input type="email" name="email" className="form-control" value={form.email} onChange={handleChange} required />
            </div>
            <div className="col-md-4 mb-3">
              <label>Celular</label>
              <input type="text" name="celular" className="form-control" value={form.celular} onChange={handleChange} />
            </div>

            <div className="col-md-4 mb-3">
              <label>Segundo Celular</label>
              <input type="text" name="celular2" className="form-control" value={form.celular2} onChange={handleChange} />
            </div>
            <div className="col-md-4 mb-3">
              <label>Fecha de Nacimiento</label>
              <input type="date" name="fechaNacimiento" className="form-control" value={form.fechaNacimiento} onChange={handleChange} />
            </div>
            <div className="col-md-4 mb-3">
              <label>Género</label>
              <select name="genero" className="form-control" value={form.genero} onChange={handleChange}>
                <option value="">Seleccione</option>
                <option value="masculino">Masculino</option>
                <option value="femenino">Femenino</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Dirección</label>
              <input type="text" name="direccion" className="form-control" value={form.direccion} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label>Departamento</label>
              <input type="text" name="departamento" className="form-control" value={form.departamento} onChange={handleChange} />
            </div>

            <div className="col-md-6 mb-3">
              <label>Padre</label>
              <input type="text" name="padre" className="form-control" value={form.padre} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label>Madre</label>
              <input type="text" name="madre" className="form-control" value={form.madre} onChange={handleChange} />
            </div>

            <div className="col-md-6 mb-3">
              <label>Documento</label>
              <input type="text" name="documento" className="form-control" value={form.documento} onChange={handleChange} required />
            </div>
            <div className="col-md-6 mb-3">
              <label>Tarifa</label>
              <select name="rateId" className="form-control" value={form.rateId} onChange={handleChange}>
                <option value="">Seleccione una tarifa</option>
                {rates.map(rate => (
                  <option key={rate._id} value={rate._id}>
                    {rate.name} - ${rate.amount}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-12 mb-3">
              <label>Hermanos</label>
              <div className="border rounded p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {sociosDisponibles.map(s => (
                  <div key={s._id} className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`sibling-${s._id}`}
                      checked={form.siblings.includes(s.id)}
                      onChange={() => toggleHermano(s.id)}
                    />
                    <label className="form-check-label" htmlFor={`sibling-${s._id}`}>
                      {s.name} - {s.documento}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-md-12 mb-3">
              <label>Descuentos</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {descuentosDisponibles.map(desc => (
                  <span
                    key={desc._id}
                    onClick={() => toggleDescuento(desc._id)}
                    style={{
                      cursor: 'pointer',
                      padding: '8px 16px',
                      borderRadius: '16px',
                      background: form.discountIds.includes(desc._id) ? '#03a9f4' : '#e0e0e0',
                      color: form.discountIds.includes(desc._id) ? 'white' : '#333'
                    }}
                  >
                    {desc.name} ({desc.percentage}%)
                  </span>
                ))}
              </div>
            </div>

            <div className="col-md-12 mb-3">
              <label>Observaciones</label>
              <textarea name="observaciones" className="form-control" value={form.observaciones} onChange={handleChange} />
            </div>

            <div className="col-md-12 form-check mb-4">
              <input type="checkbox" className="form-check-input" name="isPaymentResponsible" checked={form.isPaymentResponsible} onChange={handleChange} />
              <label className="form-check-label">Es responsable de pago</label>
            </div>

            <div className="col-12 text-end">
              <button type="submit" className="btn btn-primary" disabled={loading}>Actualizar Socio</button>
              <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)} disabled={loading}>Cancelar</button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(DatosSocio);
